import { useState } from 'react';
import { motion } from 'framer-motion';
import { FaQuestionCircle } from 'react-icons/fa';

const TechStackPredictionPopup = ({ step, setShowHint }) => {
  //   const [step, setStep] = useState(0);

  const steps = [
    {
      title: 'Step 1: Provide Description',
      description: 'Add short description about your project requirements.'
    },
    {
      title: 'Step 2: Answer MCQs',
      description: 'Answer a few multiple-choice questions about your project needs.'
    },
    {
      title: 'Step 3: AI Analysis',
      description: 'Our AI analyzes your responses to determine the best technology stack.'
    },
    {
      title: 'Step 3: Get Recommendations',
      description: 'Receive a tailored technology stack recommendation instantly!'
    }
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
      <motion.h1
        style={{ fontSize: '1.875rem', fontWeight: 'bold', marginBottom: '1.5rem' }}
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
      >
        How It Works
      </motion.h1>

      <div
        style={{ width: '24rem', padding: '1rem', border: '1px solid #ddd', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
      >
        <motion.div
          key={step}
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 20 }}
          transition={{ duration: 0.5 }}
          style={{ textAlign: 'center' }}
        >
          <FaQuestionCircle style={{ fontSize: '3rem', margin: '0 auto 1rem', color: '#3b82f6' }} />
          <h2 style={{ fontSize: '1.25rem', fontWeight: '600' }}>{steps[step].title}</h2>
          <p style={{ color: '#4b5563', marginTop: '0.5rem' }}>{steps[step].description}</p>
        </motion.div>
      </div>

      <div style={{ marginTop: '1.5rem', display: 'flex', gap: '1rem' }}>
        <button
          onClick={() => {
            setShowHint({ status: false, id: 0 });
          }}
          //   disabled={step === steps.length}
          style={{
            padding: '0.5rem 1rem',
            backgroundColor: '#3b82f6',
            color: '#fff',
            borderRadius: '4px',
            border: 'none',
            cursor: 'pointer'
            // opacity: step === steps.length - 1 ? 0.5 : 1
          }}
        >
          ok
        </button>
      </div>
    </div>
  );
};

export default TechStackPredictionPopup;
